/**
 * Утилиты для работы с аватарами
 */

/**
 * Массив градиентов для аватаров
 */
const AVATAR_GRADIENTS = [
  'linear-gradient(140deg, #5F33E1, #8B5CF6)', // Фиолетовый
  'linear-gradient(140deg, #3B82F6, #60A5FA)', // Синий
  'linear-gradient(140deg, #F4A24C, #F7C07A)', // Оранжевый
  'linear-gradient(140deg, #EF5B8D, #F48DAF)', // Розовый
  'linear-gradient(140deg, #4EAE6E, #7BC498)', // Зеленый
  'linear-gradient(140deg, #FF4949, #FF7B7B)', // Красный
  'linear-gradient(140deg, #FFD12E, #FFE380)', // Желтый
  'linear-gradient(140deg, #867AE6, #A89FED)', // Лавандовый
  'linear-gradient(140deg, #0087FF, #4FB4FF)', // Небесно-голубой
  'linear-gradient(140deg, #21C55E, #6BCB8B)', // Изумрудный
];

/**
 * Простая хеш-функция для строки
 */
function hashString(str: string): number {
  let hash = 0;
  for (let i = 0; i < str.length; i++) {
    const char = str.charCodeAt(i);
    hash = ((hash << 5) - hash) + char;
    hash = hash & hash; // Convert to 32bit integer
  }
  return Math.abs(hash);
}

/**
 * Получить градиент для аватара на основе userId
 */
export function getAvatarGradient(userId: string): string {
  const hash = hashString(userId);
  return AVATAR_GRADIENTS[hash % AVATAR_GRADIENTS.length];
}

/**
 * Получить инициалы из имени
 * Берет первые буквы первых двух слов (если слов больше 2)
 */
export function getNameInitials(name: string): string {
  if (!name) return '?';
  
  const trimmed = name.trim();
  const words = trimmed.split(' ').filter(w => w.length > 0);
  
  if (words.length === 0) return '?';
  if (words.length === 1) return words[0][0].toUpperCase();
  
  // Берем первую букву первого и второго слова
  return (words[0][0] + words[1][0]).toUpperCase();
}

/**
 * Получить инициалы пользователя для аватара
 * Приоритет: displayName + lastName > displayName > username
 * Если displayName — одно слово и есть lastName — берутся первые буквы обоих
 * Если displayName содержит несколько слов — берутся первые буквы первых 2х слов
 */
export function getUserInitials(params: {
  displayName?: string | null;
  lastName?: string | null;
  username?: string | null;
}): string {
  const { displayName, lastName, username } = params;
  
  // Если есть displayName — используем его
  if (displayName?.trim()) {
    const trimmed = displayName.trim();
    const words = trimmed.split(' ').filter(w => w.length > 0);

    // displayName — одно слово и есть фамилия → "ИФ"
    if (words.length === 1 && lastName?.trim()) {
      return (words[0][0] + lastName.trim()[0]).toUpperCase();
    }

    // displayName содержит несколько слов → стандартная логика
    return getNameInitials(trimmed);
  }
  
  // Иначе берем первую букву username
  if (username?.trim()) {
    return username[0]?.toUpperCase() || '?';
  }
  
  return '?';
}